import { render, staticRenderFns } from "./DialerCall.vue?vue&type=template&id=0b4877ce"
import script from "./DialerCall.vue?vue&type=script&lang=js"
export * from "./DialerCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports